import React from 'react'
import SvgIcon from '../../utils/Icon'

const Contenedor = ({ children, icon, title }) => {
    return (
        <div className="w-full">
            <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-[0_10px_30px_-12px_rgba(31,148,194,0.25),0_6px_16px_-8px_rgba(0,0,0,0.12)] bg-white">
                <div className="bg-gradient-to-r from-[#1f94c2ff] to-[#205087ff] px-5 md:px-7 py-2 flex items-center gap-2 border-b border-white/10">
                    <div className="w-7 h-7 rounded-lg bg-white/15 ring-1 ring-white/20 flex items-center justify-center shrink-0">
                        <SvgIcon Icon={icon} className={"w-3 h-3 text-white"} />
                    </div>
                    <h2 className="text-white font-semibold text-sm md:text-base leading-tight">
                        {title}
                    </h2>
                </div>
                <div className="bg-white p-5 md:p-7">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Contenedor